import { useEffect, useState } from "react";
import { _Entailment } from "../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { BasicPage } from "../../../theme/Component/BasicPage";
import { BasicTable } from "../../../theme/Component/BasicTable";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { Modal } from "../../../theme/Component/Modal";
import { Singleton } from '../../../../core/services/Singleton';
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import { toast } from "react-toastify";
import { AppointmentManualEditor } from "../AppointmentManual/AppointmentManual.editor";
import { AppointmentGroupManualEditor } from "../AppointmentGroupManual/AppointmentGroupManual.editor";
import { _ContributorType, _EmployeeContractType } from "../../../../core/services/dataBean/EntityCatalogVdos";
import { InputDate } from "../../../theme/Input/InputDate";
import { BasicSwitch } from "../../../theme/Component/BasicSwitch";


export const ContributorType = () => {

    const contributor = useDataBean(_ContributorType);
    const single = Singleton.getInstance();

    const [lista, setLista] = useState<any>([]);
    const [appoGroup, setAppoGroup] = useState<number>(null)
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: "Eliminar", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    useEffect(() => {
        getLista();
    }, [])

    const getLista = () => {

        contributor.instance.getContributorTypeCatalog(null).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp)
                }
            }
        )

    }

    const create = () => {
        contributor.setBean({

        });
        setModal({ ...modal, "view": true });
    }
    const deleteItem = () => {
        contributor.instance.deleteContributorType(contributor.bean.IDContributorType).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "view": false });
            }
        )

    }
    const editaItem = () => {
        if (!contributor.bean.Code) {
            toast.warning("Debe proporcionar un Código.");
            return;
        }
        if (!contributor.bean.Name) {
            toast.warning("Debe proporcionar un Nombre.");
            return;
        }
        if (!contributor.bean.Description) {
            toast.warning("Debe proporcionar una Descripción.");
            return;
        }
        if (!contributor.bean.WorkSheetCode) {
            toast.warning("Debe proporcionar un Tipo de Planilla de Pago.");
            return;
        }
        contributor.instance.updateContributorType(contributor.bean).then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const head = [
        { title: 'ID', property: 'IDContributorType', visible: true },
        { title: 'Código', property: 'Code', visible: true },
        { title: 'Nombre', property: 'Name', visible: true },
        { title: 'Descripción', property: 'Description', visible: true },
        { title: 'EPS', property: 'EPS', visible: true },
        { title: 'ARP', property: 'ARP', visible: true },
        { title: 'CCF', property: 'CCF', visible: true },
        { title: 'AFP', property: 'AFP', visible: true },
        { title: 'SENA', property: 'SENA', visible: true },
        { title: 'ICBF', property: 'ICBF', visible: true },
        { title: 'FONDO DE SOLIDARIDAD', property: 'SOLIDARY_AFP', visible: true },
        { title: 'FONDO DE SUBSISTENCIA', property: 'SUBSISTENCE_AFP', visible: true },
        { title: 'CESANTÍAS', property: 'FCE', visible: true },
        { title: 'Tipo de Planilla de Pago', property: 'WorkSheetCode', visible: true },
    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "name": `Editar ${contributor.bean.Name}`, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    return (
        <BasicPage titulo="Tipos de Cotizante">
            <div className="row">
                <div className="col-md-12">
                    <BasicTable body={lista} head={head} rowSet={contributor.setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem}></BasicTable>
                    <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                        <div className="row">
                            <div className="col-md-6">
                                <label>Código</label>
                                <input type="text" name="Code" className="form-control" value={contributor.bean.Code} onChange={contributor.handleChange} />
                            </div>
                            <div className="col-md-6">
                                <label>Nombre</label>
                                <input type="text" name="Name" className="form-control" value={contributor.bean.Name} onChange={contributor.handleChange} />
                            </div>
                            <div className="col-md-6">
                                <label>Tipo de Planilla de Pago</label>
                                <input type="text" name="WorkSheetCode" className="form-control" value={contributor.bean.WorkSheetCode} onChange={contributor.handleChange} />
                            </div>
                            <div className="col-md-6">
                                <BasicSwitch label="EPS" estado={contributor.bean.EPS} eventChange={(e: any) => { contributor.setBean({ ...contributor.bean, "EPS": e }) }}></BasicSwitch>
                            </div>
                            <div className="col-md-6">
                                <BasicSwitch label="ARP" estado={contributor.bean.ARP} eventChange={(e: any) => { contributor.setBean({ ...contributor.bean, "ARP": e }) }}></BasicSwitch>
                            </div>
                            <div className="col-md-6">
                                <BasicSwitch label="CCF" estado={contributor.bean.CCF} eventChange={(e: any) => { contributor.setBean({ ...contributor.bean, "CCF": e }) }}></BasicSwitch>
                            </div>
                            <div className="col-md-6">
                                <BasicSwitch label="AFP" estado={contributor.bean.AFP} eventChange={(e: any) => { contributor.setBean({ ...contributor.bean, "AFP": e }) }}></BasicSwitch>
                            </div>
                            <div className="col-md-6">
                                <BasicSwitch label="SENA" estado={contributor.bean.SENA} eventChange={(e: any) => { contributor.setBean({ ...contributor.bean, "SENA": e }) }}></BasicSwitch>
                            </div>
                            <div className="col-md-6">
                                <BasicSwitch label="ICBF" estado={contributor.bean.ICBF} eventChange={(e: any) => { contributor.setBean({ ...contributor.bean, "ICBF": e }) }}></BasicSwitch>
                            </div>
                            <div className="col-md-6">
                                <BasicSwitch label="FONDO DE SOLIDARIDAD" estado={contributor.bean.SOLIDARY_AFP} eventChange={(e: any) => { contributor.setBean({ ...contributor.bean, "SOLIDARY_AFP": e }) }}></BasicSwitch>
                            </div>
                            <div className="col-md-6">
                                <BasicSwitch label="FONDO DE SUBSISTENCIA" estado={contributor.bean.SUBSISTENCE_AFP} eventChange={(e: any) => { contributor.setBean({ ...contributor.bean, "SUBSISTENCE_AFP": e }) }}></BasicSwitch>
                            </div>
                            <div className="col-md-6">
                                <BasicSwitch label="CESANTÍAS" estado={contributor.bean.FCE} eventChange={(e: any) => { contributor.setBean({ ...contributor.bean, "FCE": e }) }}></BasicSwitch>
                            </div>
                            <div className="col-md-12">
                                <label>Descripción</label>
                                <input type="text" name="Description" className="form-control" value={contributor.bean.Description} onChange={contributor.handleChange} />
                            </div>
                        </div>
                    </Modal>
                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <strong>Eliminar item {contributor.bean.Name}</strong>
                    </ModalConfirm>
                </div>

            </div>
        </BasicPage>
    )
}